import { atom } from 'recoil';

import { TMyAudioTabItemType } from '~/pages/MyAudioPage/types';

export const selectedTab = atom<TMyAudioTabItemType>({
  default: 'recents',
  key: 'selectedTab',
});
